import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-chevron-down-icon]',
  template: `
    <svg:path
      d="M3.59375 5.5625L3.70312 5.48438L3.8125 5.42188L3.9375 5.39062L4.0625 5.375L4.1875 5.39062L4.3125 5.42188L4.42188 5.48438L4.53125 5.5625L8 9.04688L11.5156 5.51562L11.625 5.45312L11.75 5.40625L11.875 5.375H12L12.125 5.40625L12.2344 5.45312L12.3438 5.51562L12.4375 5.60938L12.5156 5.71875L12.5625 5.84375L12.5938 5.96875V6.09375L12.5625 6.21875L12.5156 6.34375L12.4375 6.45312L8.42188 10.4844L8.3125 10.5469L8.1875 10.5938L8.0625 10.625H7.9375L7.8125 10.5938L7.6875 10.5469L7.57812 10.4844L3.5625 6.45312L3.48438 6.34375L3.4375 6.21875L3.40625 6.09375V5.96875L3.4375 5.84375L3.48438 5.71875L3.5625 5.60938L3.59375 5.5625Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChevronDownIcon {
  readonly viewBox = input<string>('0 0 16 16');
  readonly extraClass = input<string>('');
}
